import basicJson from '../../../assets/avatar/basic.json';
import { DEFAULT_AVATAR_BODY, type Slot } from '../models/types';
import type { AvatarBox } from './itemArt';

/**
 * A base body: the generated mannequin every item was drawn on, and where each slot can be tapped.
 * Both live in `assets/avatar/`, shared with the Flutter client.
 */
export interface AvatarBodyDefinition {
  /** The body image, a square canvas the same shape as every worn layer's. */
  image: string;
  /** Tap target per slot, as fractions of the canvas. */
  zones: Readonly<Record<Slot, AvatarBox>>;
}

const basic = basicJson as unknown as { image: string; zones: Record<Slot, AvatarBox> };

export const avatarBodies: Record<string, AvatarBodyDefinition> = {
  [DEFAULT_AVATAR_BODY]: { image: `/avatar/${basic.image}`, zones: basic.zones },
};

/** The definition for `bodyId`, falling back to `basic` for bodies this build lacks. */
export const avatarBodyFor = (bodyId: string): AvatarBodyDefinition => avatarBodies[bodyId] ?? avatarBodies[DEFAULT_AVATAR_BODY]!;
